export default "<app-app-spinner *ngIf=\"appSpinnerService.appSpinner\"></app-app-spinner>\r\n<router-outlet></router-outlet>"